<div class="color-grey" >
  <app-search-bar></app-search-bar>
  <app-failure-analysis></app-failure-analysis>  
</div>